import React, { useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { getCopingSkillsData } from '../../../common/api/Practices'
import { ROUTE_ACTIVITIES_COPINGSKILLS_ALL } from 'components/common/helpers/Paths'
import { navigateTo } from '../../../common/navigation'
import { getFullAuthorById } from 'components/common/api/Courses'
import { PracticeIntro } from '../../PracticeIntro'
import useFetchByID from '../../../common/hooks/useFetchByID'
import { Button } from 'react-bootstrap'

import {
  EVENT_ACTION_PAGEVIEW,
  EVENT_CATEGORY_COPING_SKILLS,
  saveUserEvent
} from '../../../common/api/UserEvents'
import { KEY_PRACTICE_COPING_SKILLS_WP } from 'components/common/api'

export default function CopingSkillsIntro({
  cache,
  setHeaderTitle,
  setReturnPath
}) {
  const history = useHistory()
  const { copingSkillsId } = useParams()

  const cacheKey = `${ROUTE_ACTIVITIES_COPINGSKILLS_ALL}/intro/${copingSkillsId}`
  const { data, isLoaded } = useFetchByID(
    getCopingSkillsData,
    copingSkillsId,
    cache,
    cacheKey
  )

  const authorID = data && data?.acf?.content_author[0]
  const author = useFetchByID(
    getFullAuthorById,
    authorID,
    cache,
    cacheKey + '/author'
  ).data

  useEffect(() => {
    setHeaderTitle(null)
    setReturnPath(ROUTE_ACTIVITIES_COPINGSKILLS_ALL)

    saveUserEvent(
      EVENT_CATEGORY_COPING_SKILLS,
      EVENT_ACTION_PAGEVIEW,
      copingSkillsId
    )
  }, [setHeaderTitle, setReturnPath, copingSkillsId])

  const handleClick = () => {
    const url = `${ROUTE_ACTIVITIES_COPINGSKILLS_ALL}/${copingSkillsId}/practice`
    navigateTo(url, history)
  }

  const handleStartButton = () => (
    <Button variant='primary' className='w-100' onClick={handleClick}>
      Start practice
    </Button>
  )

  return (
    <PracticeIntro
      practiceId={copingSkillsId}
      isLoading={isLoaded}
      authors={author}
      practiceData={data}
      handleStartButton={handleStartButton}
      practiceType={KEY_PRACTICE_COPING_SKILLS_WP}
    />
  )
}
